import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    notPlayable: {
        id: "planCard.notPlayable",
    },
    back: {
        id: "general.back",
    },
    loading: {
        id: "general.loading",
    },
    unknown: {
        id: "general.unknown",
    },
    cantPlay: {
        id: "plan.cantPlay",
    },
    join: {
        id: "share.join",
    },
    joinTitle: {
        id: "join.modal.title",
    },

    joinTitle1: {
        id: "join.modal.1.title",
    },
    joinContent1: {
        id: "join.modal.1.content",
    },
    joinTitle2: {
        id: "join.modal.2.title",
    },
    joinTitle3: {
        id: "join.modal.3.title",
    },
    notFound: {
        id: "error.404.title",
    },
    displayTitle: {
        id: "display.title",
    },
    displayTask: {
        id: "display.task",
    },
    displaySimple: {
        id: "display.simple",
    },
    displaySimpleDescription: {
        id: "display.simple.description",
    },
    displayChoose: {
        id: "display.choose",
    },
    displayPlayful: {
        id: "display.playful",
    },
    displayPlayfulDescription: {
        id: "display.playful.description",
    },
    displayInfo: {
        id: "display.info",
    },
    classLabel: {
        id: "pushNotification.classroom.class.label",
        defaultMessage: "Class (this will allow your students to easily connect with push notifications)",
    },
    next: {
        id: "general.next",
    },
    skip: {
        id: "general.skip"
    },
    or: {
        id: "general.or",
    },
    joinAppTitle1: {
        id: "join.modal.app.1",
    },
    joinAppTitle2: {
        id: "join.modal.app.2",
    },
    lastly: {
        id: "general.lastly",
    },
});

export default messages;
